import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PREDEFINED_TEMPLATE_API } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

// interface UseGetPredefinedTemplateListProps {
//   queryParams?: Omit<UseQueryOptions, "queryKey">
// }

const getPredefinedTemplateList = async () =>
  await axiosAuth.get(`${PREDEFINED_TEMPLATE_API}`);

const useGetPredefinedTemplateList = (queryParams?: Omit<UseQueryOptions, "queryKey">): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["predefined-template"],
    queryFn: () => getPredefinedTemplateList(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: (queryParams?.enabled ?? true),
  });
};

export default useGetPredefinedTemplateList;
